import React from "react";
import { useEffect, useState } from "react";
import { Country } from "../../../../utils/Country";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./addUser.scss";
import { toast } from "react-toastify";

function AddUser({ handleUpdateStatus, fetchEmployeesDetail }) {
  const [Code, setCode] = useState("+91");
  const [hidden, sethidden] = useState(true);
  const [employeeDetails, setEmployeeDetails] = useState({
    email_id: "",
    emp_role: [],
    password: "",
    emp_country_code: Code,
    emp_phone_no: "",
    emp_name: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "emp_role") {
      const rolesArray = value.split(",").map((role) => role.trim()); // Trim to remove any extra spaces
      setEmployeeDetails((prevState) => ({
        ...prevState,
        [name]: rolesArray,
      }));
    } else {
      setEmployeeDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(
        "https://ballersapi.ballerslife.co/api/v1/admin/add_an_employee",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(employeeDetails),
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        toast.success(data.message);
        handleUpdateStatus();
        fetchEmployeesDetail();
      } else if (response.status === 403) {
        toast.error(data.detail);
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.error("Error adding employee:", error);
    }
  };

  return (
    <>
      <div className="addUserMain">
        <p className="closeBtnUser" onClick={handleUpdateStatus}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fefbfb"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-x"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </p>
        <div className="credDiv">
          <div className="addUserMainSec">
            <div className="detailsFieldAddUser">
              <p>Name :</p>
            </div>
            <div className="phoneNoUserAcc">
              <input
                type="text"
                name="emp_name"
                placeholder="Please provide your Name"
                required
                value={employeeDetails.emp_name}
                onChange={handleInputChange}
              />
            </div>
            <div className="detailsFieldAddUser">
              <p>Phone No :</p>
            </div>

            <div className="phoneNoUserAcc">
              <div className="code" onClick={() => sethidden(!hidden)}>
                {Code}
                {hidden ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                )}
              </div>
              {hidden ? (
                <></>
              ) : (
                <div className="countrycode">
                  {Country.map((country) => {
                    return (
                      <div
                        key={country.code}
                        onClick={() => {
                          sethidden((prev) => !prev);
                          setCode(country.dial_code);
                          setEmployeeDetails({
                            ...employeeDetails,
                            emp_country_code: country.dial_code,
                          });
                        }}
                      >
                        {country.name + " " + country.dial_code}
                      </div>
                    );
                  })}
                </div>
              )}
              <input
                type="text"
                id="phone_no"
                name="phone_no"
                pattern="[0-9]*"
                placeholder="Please provide your Phone number"
                required
                value={employeeDetails.phone_no}
                onChange={handleInputChange}
              />
            </div>
            <div className="detailsFieldAddUser">
              <p>Email :</p>
            </div>
            <div className="phoneNoUserAcc">
              <input
                type="text"
                name="email_id"
                placeholder="Please provide your Email"
                required
                value={employeeDetails.email_id}
                onChange={handleInputChange}
              />
            </div>
            <div className="detailsFieldAddUser">
              <p>Employee Role:</p>
            </div>
            <div className="phoneNoUserAcc">
              <input
                type="text"
                name="emp_role"
                placeholder="Please provide role(s) separated by commas"
                required
                onChange={handleInputChange}
              />
            </div>
            <div className="detailsFieldAddUser">
              <p>Password :</p>
            </div>
            <div className="phoneNoUserAcc">
              <input
                type="text"
                name="password"
                placeholder="Please provide your Password"
                required
                value={employeeDetails.password}
                onChange={handleInputChange}
              />
            </div>
            <div className="btnMainSec">
              <div className="updateBtn" onClick={handleSubmit}>
                <p>Add User</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddUser;
